import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid2 } from '@mui/material';
import { BOX_SHADOW } from '../../shared/constants';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useAuthStore from '../../shared/store/useAuthStore';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';
import CustomDivider from '../../shared/utils/CustomDivider';
import { useToaster } from '../../shared/utils/ToasterProvider';
import useResponsive from '../../shared/utils/Responsive';
import useTabs from '../../shared/hook/useTabs';
import TabsForDays from '../../shared/components/Tabs/TabsForDays';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import { CustomButtonContained, CustomButtonOutline } from '../../shared/utils/CustomButton';
import { TimeSlotChip } from '../../shared/components/TimeSlotChip';
import SloteCard from '../../shared/components/SloteCard';
import { useGetOnlineCourseDetail } from '../../assets/api/useGetApi';
import { useSlotStore } from '../../shared/store/useSlotStore';
import useVisitedPathStore from '../../shared/store/useVisitedPathStore';
import { addDaysToToday, groupSlotsByDay } from '../../shared/formatter';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CustomMinimalDatePicker } from '../../shared/components/FormFields/CustomMinimalDatePicker';
import { useSloteDateStore } from '../../shared/store/useSloteDateStore';
import useOneToManySlotStore from '../../shared/store/useOneToManySlotStore';
import { PriceUi} from "./SubscribedCardTypeThree";
import CouponBoxUi from '../../shared/utils/CouponBoxUi';
import { useCoursePayment } from '../../shared/utils/useCoursePayment';
import { useCourseFreePayment } from '../../shared/utils/useCourseFreePayment';
import useCouponStore from '../../shared/store/useCouponStore';
import { FullScreenLoader } from './SubscribedCard';
import React from 'react';

export function transformSlotData(levelData = []) {
    return levelData?.map((item, index) => {
        const sessionId = index + 1;
        const slottime = item?.slottime?.map((slot, i) => ({
            id: i + 1,
            session_id: sessionId,
            start_time: slot?.start_time,
            end_time: slot?.end_time,
            day: item?.day
        })) || [];

        return {
            id: sessionId,
            day: item?.day,
            slottime
        };
    });
}

const SubscribedCardTypeSix = ({ item }) => {
    const [isProcessing, setIsProcessing] = React.useState(false);
    const { couponData } = useCouponStore();
    const { selectedSlotDate, setDate } = useSloteDateStore();
    const [selectedDate, setSelectedDate] = useState(selectedSlotDate);
    const endDate = addDaysToToday(selectedDate)
    const formattedDate = selectedDate?.format('YYYY-MM-DD');
    const { value, handleChange } = useTabs(0);
    const { submittedSlots, addOrUpdateSlot } = useSlotStore()
    const { setOneToManySlot, oneToManySlot } = useOneToManySlotStore()
    const { slug } = useParams();
    const { data: CourseDetail, isLoading } = useGetOnlineCourseDetail({ slug });
    const isOneToMany = CourseDetail?.data?.online_type === "1tomany"
    const data = transformSlotData(CourseDetail?.data?.monthly_package?.sessions);
    const isSmallScreen = useResponsive("sm");
    const token = useAuthStore((state) => state.accessToken);
    const user = useAuthStore((state) => state.user);
    const { open: openDialog, handleClickOpen, handleClose } = useDialog();
    const handleClickOpenSlot = () => {
        if (!token) {
            useVisitedPathStore.getState().setLastVisitedPath(location.pathname);
            localStorage.setItem("lastVisitedPath", location.pathname);
            navigate("/StudentLogin")
            return
        }
        handleClickOpen()
    }
    const navigate = useNavigate();
    const location = useLocation();
    const { showToaster } = useToaster();
    const paymentHook = couponData?.finalPrice === 0 ? useCourseFreePayment : useCoursePayment;
    const paymentcallback = couponData?.finalPrice === 0 ? isOneToMany ? "freecourse/collab-course-payment-callback-onetomany" : "freecourse/payment-callback" : isOneToMany ? "collab-course-payment-callback-onetomany" : "collab-course-payment-callback";
    const { handlePayment, SuccessDialog } = paymentHook({
        course_id: CourseDetail?.data?.id,
        course_Name: CourseDetail?.data?.title,
        apartment_name: "online",
        coverImage: CourseDetail?.data?.cover_image,
        apartments_id: null,
        batch_id: null,
        start_date: isOneToMany ? CourseDetail?.data?.start_date : formattedDate,
        end_date: isOneToMany ? CourseDetail?.data?.end_date : endDate,
        order_details: {
            ...item,
            ...(isOneToMany ? oneToManySlot : submittedSlots),
        },
        other_detail: {
            course_type: 6,
            online: 1,
            seats: CourseDetail?.data?.seats,
            sessions: isOneToMany ? oneToManySlot : groupSlotsByDay(submittedSlots),
        },
        callback_url: paymentcallback,
        isOnline: true,
        onProcessingChange: setIsProcessing

    });

    const handleClearSlot = (sessionId) => {
        setSelectedSlots((prev) => prev.filter(slot => slot?.session_id !== sessionId));
    };
    const [selectedSlots, setSelectedSlots] = useState([]);

    const handleSlotSelect = (sessionId, slot) => {
        if (selectedSlots?.length > CourseDetail?.data?.monthly_package?.max_slots - 1) {
            showToaster('Warning', `You can only select up to ${CourseDetail?.data?.monthly_package?.max_slots} slots`, 'warning');
            return;
        }

        setSelectedSlots(prev => {
            const filtered = prev.filter(s => s.session_id !== sessionId);
            return [...filtered, slot];
        });
    };

    const ChooseSlot = ({ item }) => (
        <Grid2 container gap="1rem">
            {item?.slottime?.map((slot, index) => {
                const isSelected = selectedSlots.find(s => s?.session_id === item.id)?.id === slot.id;
                return (
                    <Grid2 children size={{ xs: 5.5, md: 3.5 }} key={index}>
                        <TimeSlotChip
                            label={`${slot?.start_time}-${slot?.end_time}`}
                            selected={isSelected}
                            onClick={() => handleSlotSelect(item.id, slot)}
                        />
                    </Grid2>
                );
            })}
        </Grid2>
    );

    // const ChooseSlotOneToMany = ({ item }) => (
    //     <Grid2 container gap="1rem">
    //         {item?.sessions?.map((slot, index) => {
    //             return (
    //                 <Grid2 children size={12} key={index}>
    //                     <SloteCard key={index} day={slot?.day || ''} start_time={slot?.slottime?.[0]?.start_time} end_time={slot?.slottime?.[0]?.end_time} />
    //                 </Grid2>
    //             );
    //         })}
    //     </Grid2>
    // );

    // const ChooseSlotOneToMany = ({ item, onChange }) => {
    //     const [sessions, setSessions] = useState(() =>
    //         item.sessions.map((session) => ({
    //             day: session.day,
    //             selectedSlot: session.slottime[0],
    //         }))
    //     );

    //     // // 🧮 Build response whenever sessions change
    //     // const response = useMemo(
    //     //     () => ({
    //     //         slotname: item.slotname,
    //     //         sessions: sessions.map((s) => ({
    //     //             day: s.day,
    //     //             slottime: [s.selectedSlot],
    //     //         })),
    //     //     }),
    //     //     [sessions, item.slotname]
    //     // );


    //     const handleSelect = (dayIndex, slot) => {
    //         setSessions((prev) => {
    //             const updated = prev.map((s, i) =>
    //                 i === dayIndex ? { ...s, selectedSlot: slot } : s
    //             );

    //             // ✅ notify parent right away with new response
    //             setTara({
    //                 slotname: item.slotname,
    //                 sessions: updated.map((s) => ({
    //                     day: s.day,
    //                     slottime: [s.selectedSlot],
    //                 })),
    //             });

    //             return updated;
    //         });
    //     };


    //     return (
    //         <Grid2 container gap="1rem">
    //             <Grid2 size={12}>
    //                 {item.sessions.map((session, dayIndex) => (
    //                     <Box key={dayIndex}>
    //                         <Typography variant="body2" mb={2}>
    //                             {session?.day}
    //                         </Typography>
    //                         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    //                             {session.slottime.map((slot, slotIndex) => (
    //                                 <TimeSlotChip
    //                                     key={slotIndex}
    //                                     label={`${slot.start_time}-${slot.end_time}`}
    //                                     selected={
    //                                         sessions[dayIndex].selectedSlot.start_time ===
    //                                         slot.start_time &&
    //                                         sessions[dayIndex].selectedSlot.end_time ===
    //                                         slot.end_time
    //                                     }
    //                                     onClick={() => handleSelect(dayIndex, slot)}
    //                                 />
    //                             ))}
    //                         </Box>
    //                         <CustomDivider />
    //                     </Box>
    //                 ))}
    //             </Grid2>
    //         </Grid2>
    //     );
    // };

    // const ChooseSlotOneToMany = forwardRef(({ item }, ref) => {
    //     const [sessions, setSessions] = useState(() =>
    //         item.sessions.map((session) => ({
    //             day: session.day,
    //             selectedSlot: session.slottime[0],
    //         }))
    //     );

    //     const taraRef = useRef(null);

    //     const handleSelect = (dayIndex, slot) => {
    //         setSessions((prev) => {
    //             const updated = prev.map((s, i) =>
    //                 i === dayIndex ? { ...s, selectedSlot: slot } : s
    //             );

    //             taraRef.current = {
    //                 slotname: item.slotname,
    //                 sessions: updated.map((s) => ({
    //                     day: s.day,
    //                     slottime: [s.selectedSlot],
    //                 })),
    //             };

    //             return updated;
    //         });
    //     };

    //     // 🔓 Expose method to parent via ref
    //     useImperativeHandle(ref, () => ({
    //         getTara: () => taraRef.current,
    //     }));

    //     return (
    //         <Grid2 container gap="1rem">
    //             <Grid2 size={12}>
    //                 {item.sessions.map((session, dayIndex) => (
    //                     <Box key={dayIndex}>
    //                         <Typography variant="body2" mb={2}>
    //                             {session?.day}
    //                         </Typography>
    //                         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    //                             {session.slottime.map((slot, slotIndex) => (
    //                                 <TimeSlotChip
    //                                     key={slotIndex}
    //                                     label={`${slot.start_time}-${slot.end_time}`}
    //                                     selected={
    //                                         sessions[dayIndex].selectedSlot.start_time ===
    //                                         slot.start_time &&
    //                                         sessions[dayIndex].selectedSlot.end_time ===
    //                                         slot.end_time
    //                                     }
    //                                     onClick={() => handleSelect(dayIndex, slot)}
    //                                 />
    //                             ))}
    //                         </Box>
    //                         <CustomDivider />
    //                     </Box>
    //                 ))}
    //             </Grid2>
    //         </Grid2>
    //     );
    // });


    const ChooseSlotOneToMany = forwardRef(({ item }, ref) => {
        const [sessions, setSessions] = useState(() =>
            oneToManySlot
                ? oneToManySlot?.map((session) => ({
                    day: session?.day,
                    selectedSlot: session?.slottime[0], // default pick first slot
                }))
                : item?.sessions?.map((session) => ({
                    day: session?.day,
                    selectedSlot: session?.slottime[0], // default pick first slot
                }))
        );

        const taraRef = useRef(null);

        // ✅ Keep taraRef in sync
        useEffect(() => {
            taraRef.current = sessions?.map((s) => ({
                day: s?.day,
                slottime: [s?.selectedSlot],
            }))
        }, [sessions, item.slotname]);

        // ✅ When user selects a slot for Day 1 → apply to ALL days
        const handleSelect = (slot) => {
            const updated = sessions?.map((s) => ({
                ...s,
                selectedSlot: slot, // same slot for all days
            }));

            setSessions(updated);

            // also update ref
            taraRef.current = updated?.map((s) => ({
                day: s?.day,
                slottime: [s?.selectedSlot],
            }))

        };

        // 🔓 Expose method to parent
        useImperativeHandle(ref, () => ({
            getTara: () => taraRef.current,
        }));

        return (
            <Grid2 container gap="1rem">
                <Grid2 size={12}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        {item?.sessions[0]?.slottime?.map((slot, slotIndex) => (
                            <TimeSlotChip
                                key={slotIndex}
                                label={`${slot?.start_time}-${slot?.end_time}`}
                                selected={
                                    sessions[0]?.selectedSlot?.start_time === slot?.start_time &&
                                    sessions[0]?.selectedSlot?.end_time === slot?.end_time
                                }
                                onClick={() => handleSelect(slot)}
                            />
                        ))}
                    </Box>
                </Grid2>
            </Grid2>
        );
    });




    //   const [selectedOneToManySlots, setSelectedOneToManySlots] = useState({});
    const tabsData = data?.map((item) => ({
        label: item?.day,
        component: <ChooseSlot item={item} />,
    }));

    const parentRef = useRef();


    const tabDataOnetoMany = CourseDetail?.data?.monthly_package?.sessions?.map((item, index) => ({
        label: item?.slotname,
        component: (
            <ChooseSlotOneToMany
                item={item}
                ref={parentRef}
            />
        ),
    }));


    const tabsDatamain = isOneToMany ? tabDataOnetoMany : tabsData
    const handleSubmit = () => {
        if (CourseDetail?.data?.online_type === "1tomany") {
            // setOneToManySlot(CourseDetail?.data?.monthly_package?.sessions[value]);
            setOneToManySlot(parentRef.current.getTara());
            handleClose();
        } else {
            if (selectedSlots?.length < CourseDetail?.data?.monthly_package?.max_slots) {
                showToaster('Warning', `Select Up to  ${CourseDetail?.data?.monthly_package?.max_slots} slots`, 'warning');
                return;
            }
            if (!selectedDate) {
                showToaster('Warning', `Please Select Start Date`, 'warning');
                return;
            }
            addOrUpdateSlot(selectedSlots);
            handleClose();
        }
    };
    const isSubmittedSlot = isOneToMany ? oneToManySlot : submittedSlots.length > 0
    return (
        <>
            <FullScreenLoader open={isProcessing} />
            <Card
                sx={{
                    boxShadow: BOX_SHADOW,
                    border: "1px solid #F0F0F0",
                    p: "32px 22px",
                    borderRadius: isSmallScreen ? "10px" : "40px",
                    position: isSmallScreen ? "fixed" : "relative",
                    bottom: "0",
                    bgcolor: "#fff",
                    zIndex: 100,
                    width: isSmallScreen ? "90%" : "auto",
                }}>

                {!isSmallScreen && (
                    <CardContent>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <PriceUi totalPrice={item?.price} isOnline={true} />
                        </Box>
                        <Box my={4}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={isSubmittedSlot ? handlePayment : handleClickOpenSlot}
                                disabled={isSubmittedSlot && token && user?.role !== 'student'}
                            >
                                {isSubmittedSlot ? "Purchase Now" : "Select Slots"}
                            </Button>
                        </Box>
                        {isSubmittedSlot && <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main' mt={2} style={{ cursor: "pointer" }} onClick={() => { handleClickOpen(); setSelectedSlots(submittedSlots) }}>
                            Any changes ?? Edit your slot
                        </Typography>

                        }
                        <CouponBoxUi totalPrice={item?.price} />

                    </CardContent>
                )}
                {
                    isSmallScreen && <>
                        <CardContent >
                            <Box
                                sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
                            >
                                < PriceUi totalPrice={item?.price} isOnline={true} />

                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={isSubmittedSlot ? handlePayment : handleClickOpenSlot}
                                    disabled={isSubmittedSlot && token && user?.role !== 'student'}
                                >
                                    {isSubmittedSlot ? "Purchase Now" : "Select Slots"}
                                </Button>
                            </Box>
                            {isSubmittedSlot && <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main' mt={2} style={{ cursor: "pointer" }} onClick={() => { handleClickOpen(); setSelectedSlots(submittedSlots) }}>
                                Any changes ?? Edit your slot
                            </Typography>

                            }
                            <CouponBoxUi totalPrice={item?.price} />

                        </CardContent>
                    </>
                }
            </Card>

            <MainDialogBox open={openDialog} handleClose={() => { setSelectedSlots(submittedSlots); handleClose(); }} width="50%">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Typography variant='h2' fontWeight={500} textAlign="center" mb={4}>
                        Choose Your Comfortable Training Day
                    </Typography>
                    <Typography variant='body2' color='grey.400' textAlign="center">
                        Plan your learning journey at your own pace — pick the day you wish to start, and we’ll organize your weekly training schedule just for you!
                    </Typography>
                    <CustomDivider />
                    {
                        !isOneToMany && <>
                            <Typography variant='body2'>Select Date From You Want to Start</Typography>
                            <CustomMinimalDatePicker
                                value={selectedDate}
                                onChange={(val) => {
                                    setSelectedDate(val);
                                    setDate(val);
                                }}
                                minDate={new Date()}
                            />

                            <CustomDivider size={"1rem"} />
                            <Typography variant='body2' mb={2}>Select Upto {CourseDetail?.data?.monthly_package?.max_slots} Slots</Typography>
                        </>
                    }


                    <Typography variant='body2' color='grey.400' mb={2}>Choose The Day</Typography>
                    <TabsForDays tabs={tabsDatamain} value={value} onChange={handleChange} />

                    {tabsDatamain?.map((tab, index) => (
                        <TabPanel key={index} value={value} index={index}>
                            {tab.component}
                        </TabPanel>
                    ))}

                    {
                        !isOneToMany && <>
                            <CustomDivider />
                            <Typography variant='body2' color='grey.400' mb={2}>Selected Slot</Typography>
                            {
                                selectedSlots?.map((slot, index) => (
                                    <SloteCard isRemove={true} key={index} day={data[slot.session_id - 1]?.day || ''} slot={slot} handleClear={() => handleClearSlot(slot.session_id)} />
                                ))
                            }
                            <CustomDivider />
                        </>
                    }

                    <Box display="flex" justifyContent="end" gap={2} mt={5}>
                        <CustomButtonOutline buttonText="Close" onClick={() => { setSelectedSlots(submittedSlots); handleClose(); }} />
                        <CustomButtonContained buttonText="Submit" onClick={handleSubmit} />
                    </Box>
                </LocalizationProvider>
            </MainDialogBox>
            <SuccessDialog />
        </>
    );
};

export default SubscribedCardTypeSix;






